import React from 'react';

export const Eraser = () => (
    <g>
        <path d="M18.9998 19.9998H8.49982L4.28982 15.6998C4.10357 15.5125 3.99902 15.259 3.99902 14.9948C3.99902 14.7306 4.10357 14.4772 4.28982 14.2898L14.2898 4.28982C14.4772 4.10357 14.7306 3.99902 14.9948 3.99902C15.259 3.99902 15.5125 4.10357 15.6998 4.28982L20.6998 9.28982C20.8861 9.47718 20.9906 9.73063 20.9906 9.99482C20.9906 10.259 20.8861 10.5125 20.6998 10.6998L11.4998 19.9998" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.0002 13.3L11.7002 7" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
);